// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ct-4";
export var closeButton = "_ct-6";
export var dismissButton = "_ct-3";
export var editImageWithAiContainer = "_ct-8";
export var imageUploadWrapper = "_ct-7";
export var misspelledWord = "_ct-5";
export var spellCheckContainer = "_ct-2";
export var spin = "_ct-1";
export var spinning = "_ct-0";